module.exports = __webpack_public_path__ + "01_medium_brown.e2196a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_medium_brown.png
// module id = Wkfk
// module chunks = 0